/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./round')} */
module.exports = Math.round;

